import Button from "e.sic-platform.webclient/src/components/button/Button";
import { Upload } from "e.sic-platform.webclient/src/components/svg/svgImageList";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";

export default function RunVideoConversionButton(props:{onClick: () => void, disabled?: boolean}) {
  const { themeClass } = useThemeService();

  return (
    <Button
        id="run-conversion-sc"
        onClick={props.onClick}
        disabled={props.disabled}
        icon={{
          svg: Upload,
          textKey: "RunVideoConversionButton.run",
          className: themeClass(["icon-conversion"]),
        }}
        className={themeClass(["btn-huge", "run-ai-button"])}
      />
  )
}
